import { ISODateString } from "@m7-health/shared-utils";

import { IOpenShift } from "~/api/openShift";

import { EStaffTypeKey, Uuid } from "@/common/types";

// this is from the backend version of this type
// not as significant as the StaffShifts version
type TComparableAttributes = "shiftIncentiveLevelId" | "shiftCount" | "note";

export type TWithIsoDate<T> = Omit<
  T,
  "date" | "createdAt" | "updatedAt" | "deletedAt" | "startDateTime"
> & {
  date: ISODateString;
  createdAt: ISODateString;
  updatedAt: ISODateString;
  deletedAt: ISODateString;
  startDateTime: ISODateString;
};
export type TOpenShiftUpdatableFields = Partial<{
  [key in TComparableAttributes]: {
    from: TWithIsoDate<IOpenShift>[key];
    to: TWithIsoDate<IOpenShift>[key];
  };
}>;

// All versions of event payloads should be defined here
type TPayloadV1 = {
  openShift: Pick<
    IOpenShift,
    | "id"
    | "scheduleId"
    | "shiftType"
    | "durationSeconds"
    | "staffCategoryKey"
    | "shiftIncentiveLevelId"
    | "note"
    | "shiftCount"
    | "date"
    | "startDateTime"
  > & {
    staffTypeKey?: EStaffTypeKey;
    isAutoGenerated: boolean;
  };
  updatedFields: TOpenShiftUpdatableFields;
  origin: TOpenShiftOrigin;
};

type TOpenShiftOrigin =
  | {
      type: "edit-open-shift";
      id: IOpenShift["id"];
    }
  | {
      type: "approved-open-shift-request";
      id: Uuid;
    };

export namespace OpenShiftUpdated {
  export enum EVersions {
    "v1" = "1",
  }

  export type OpenShiftOrigin = TOpenShiftOrigin;
  export type Differences = TOpenShiftUpdatableFields;
  export type Payloads = TPayloadV1;
  export type PayloadByVersion = {
    [EVersions.v1]: TPayloadV1;
  };
}
